import { render, staticRenderFns } from "./ResearchMethod.vue?vue&type=template&id=4cd101be&"
import script from "./ResearchMethod.vue?vue&type=script&lang=js&"
export * from "./ResearchMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd101be')) {
      api.createRecord('4cd101be', component.options)
    } else {
      api.reload('4cd101be', component.options)
    }
    module.hot.accept("./ResearchMethod.vue?vue&type=template&id=4cd101be&", function () {
      api.rerender('4cd101be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/eglt/ResearchMethod.vue"
export default component.exports